export function NumberFormatter(num) {
    if (num === null || num === undefined || isNaN(num)) return "0";

    const absNum = Math.abs(Number(num));

    if (absNum >= 1.0e+12) {
        return (num / 1.0e+12).toFixed(2).replace(/\.00$/, "") + "T";
    } else if (absNum >= 1.0e+9) {
        return (num / 1.0e+9).toFixed(2).replace(/\.00$/, "") + "B";
    } else if (absNum >= 1.0e+6) {
        return (num / 1.0e+6).toFixed(2).replace(/\.00$/, "") + "M";
    } else if (absNum >= 1.0e+3) {
        return (num / 1.0e+3).toFixed(2).replace(/\.00$/, "") + "K";
    } else {
        return num.toString();
    }
}
